import { useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import type { ReactNode } from 'react'

const subscribe = () => () => {}

/**
 * Client-only portal into document.body. Renders nothing on the server (so
 * prerender never touches document), and portals on the client after mount.
 * Use it instead of calling createPortal(..., document.body) directly.
 */
export function Portal({ children }: { children: ReactNode }) {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  )
  if (!isClient) return null
  return createPortal(children, document.body)
}
